// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer[data-v-002a9054]{position:relative;z-index:1}", ""]);
// Exports
module.exports = exports;
